let $ = jQuery;

let foundation = require('foundation-sites');
$(document).foundation();

let objectFitImages = require('object-fit-images');
objectFitImages();

// Import Drupal Behaviors
if(typeof Drupal !== 'undefined') {

  Drupal.behaviors.alertBanner = require('./common/alert-banner');
  Drupal.behaviors.horizScroller = require('./common/horiz-scroller');
  Drupal.behaviors.tabs = require('./common/tabs');
  Drupal.behaviors.textFields = require('./common/textfields');
  Drupal.behaviors.embedVideo = require('./common/embed-video');
  Drupal.behaviors.legalWysiwygNav = require('./common/legal-wysiwyg');
  Drupal.behaviors.dropdowns = require('./common/dropdowns');
  Drupal.behaviors.videoEmbed = require('./common/video-embed');
  Drupal.behaviors.whatSetsUsApart = require('./common/what-sets-us-apart');
  Drupal.behaviors.nav = require('./nav/main');
  Drupal.behaviors.tabbedContent = require('./package/tabbed-content');
  Drupal.behaviors.eventsCalendar = require('./events/calendar');
  Drupal.behaviors.dropboxes = require('./form-elements/dropbox');
  Drupal.behaviors.glossaryIndex = require('./glossary/index');
  Drupal.behaviors.glossaryToolTips = require('./glossary/tool-tips');
  Drupal.behaviors.dashboardFilterForm = require('./dashboard/filter-form');
  Drupal.behaviors.dashboardNavigation = require('./dashboard/navigation');
  Drupal.behaviors.dashboardPagination = require('./dashboard/pagination');
  Drupal.behaviors.dashboardBackToTop = require('./dashboard/back-to-top');
  Drupal.behaviors.profileSectionAboutMe = require('./profile/section-about-me');
  Drupal.behaviors.profileSectionListSeeMore = require('./profile/section-list-see-more');
  Drupal.behaviors.searchRelatedPeople = require('./search/related-people');
  Drupal.behaviors.landingPageFilters = require('./search/search-filters');
  Drupal.behaviors.footerIconList = require('./footer/footer-icon-list');
  Drupal.behaviors.footerSearch = require('./footer/footer-search');
  Drupal.behaviors.homepageMenu = require('./homepage/menu');
  Drupal.behaviors.homepageHeader = require('./homepage/header');
  Drupal.behaviors.homepageCareScience = require('./homepage/care-science');
  Drupal.behaviors.homepageInnovation = require('./homepage/innovation');
  Drupal.behaviors.homepageOutcomes = require('./homepage/outcomes');
  Drupal.behaviors.menuCollapsible = require('./common/menu-collapsible');
  Drupal.behaviors.dialog = require('./plugins/dialog');
  Drupal.behaviors.galleryCarousel = require('./gallery/gallery-carousel');
  Drupal.behaviors.giveValidator = require('./give/give-validator');
  Drupal.behaviors.labsPublications = require('./labs/publications');
  Drupal.behaviors.labsNav = require('./labs/nav');
  Drupal.behaviors.registerStickyProfile = require('./registration/sticky-profile');
  Drupal.behaviors.landingPageSearch = require('./search/landing-pages');
}
else {

  // Initialize for Styleguide
  require('./plugins/dialog');
  require('./common/textfields');
  require('./common/menu-collapsible');
  require('./common/video-embed');
  require('./common/what-sets-us-apart');

  require('./footer/footer-icon-list');

  require('./package/tabbed-content');

  require('./homepage/menu');
  require('./homepage/header');
  require('./homepage/care-science');
  require('./homepage/innovation');
  require('./homepage/outcomes');

  require('./search/search-filters');
  require('./gallery/gallery-carousel');

}

// React Components
